<template>
  <MainLayout page-name="fees-for-stop">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="calculation" @click="clickCalculation">料金計算</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">補正登録</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true"/>
        <RegistrationSymbol v-model="simpleSearchFormModel.registration_symbol" :searchCond="true" :autocomplete-list="registrationSymbolSet" />
        <BillToCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" />
        <ActionType v-model="simpleSearchFormModel.action_type" :searchCond="true" :initialize="true" label="" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'registration_symbol', order: 'ascending' }"
      :selectable="deletable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <BillingYmColumn :sortable="true" />
        <RegistrationSymbolColumn :sortable="true" />
        <ActionTypeNameColumn :sortable="true" />
        <DateTimeColumn label="日時" prop="action_time" :sortable="true" />
        <BillToCodeColumn label="請求先" :sortable="true" />
        <CallsignColumn :sortable="true" /> -->
        <!-- <FeeColumn label="停留料（税抜き）" prop="stop_fee_without_tax" :sortable="true" />
        <FeeColumn label="停留料（消費税額）" prop="stop_fee_tax" :sortable="true" /> -->
        <!-- <FeeColumn label="停留料（税込）" prop="stop_fee_with_tax" :sortable="true" :formatter="formatter" />
        <RegistTypeColumn :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
        <BillingYmColumn />
        <RegistrationSymbolColumn />
        <ActionTypeNameColumn />
        <DateTimeColumn label="日時" prop="action_time" />
        <BillToCodeColumn label="請求先" />
        <CallsignColumn />
        <!-- 20220509髙森修正 -->
        <!-- <FeeColumn label="停留料（税込）" prop="stop_fee_with_tax" :formatter="formatter" /> -->
        <FeeColumn label="停留料（税抜）" prop="stop_fee_without_tax" :formatter="formatter" />
        <RegistTypeColumn />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" />
      </template>
    </Table>
    <FeesForStopCalculationDialog
      :visible.sync="calculationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForStopRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <FeesForStopDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      @search="detailSearch"
    />
    <FeesForStopEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import RegistrationSymbolColumn from '@/components/molecules/table/RegistrationSymbolColumn.vue'
import ActionTypeNameColumn from '@/components/molecules/table/ActionTypeNameColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import CallsignColumn from '@/components/molecules/table/CallsignColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import RegistTypeColumn from '@/components/molecules/table/RegistTypeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import FeesForStopCalculationDialog from '@/components/pages/calculation/feesForStop/FeesForStopCalculationDialog.vue'
import FeesForStopRegisterDialog from '@/components/pages/calculation/feesForStop/FeesForStopRegisterDialog.vue'
import FeesForStopDetailSearchDialog from '@/components/pages/calculation/feesForStop/FeesForStopDetailSearchDialog.vue'
import FeesForStopEditDialog from '@/components/pages/calculation/feesForStop/FeesForStopEditDialog.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    RegistrationSymbol,
    ActionType,
    BillToCode,
    SimpleSearch,
    Table,
    RegistrationSymbolColumn,
    ActionTypeNameColumn,
    DateTimeColumn,
    BillToCodeColumn,
    CallsignColumn,
    FeeColumn,
    RegistTypeColumn,
    BlankColumn,
    MenuColumn,
    FeesForStopCalculationDialog,
    FeesForStopRegisterDialog,
    FeesForStopDetailSearchDialog,
    FeesForStopEditDialog
  },
  mixins: [
    RegistrationSymbolAutocompleteLoader,
    CustomerAutocompleteLoader,
    AirportAutocompleteLoader
  ],
  data () {
    return {
      title: '停留料',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        registration_symbol: '',
        bill_to_code: '',
        action_type: ''
      },
      currentRow: {},
      calculationDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForStopSearchCond')
    this.loadRegistrationSymbol()
    this.loadCustomer()
    this.loadAirport()
  },
  methods: {
    clickCalculation () {
      this.calculationDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('feesForStopSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopSearchCond'))
      this.$axios
        .get('/search-fees-for-stop', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('feesForStopSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      const currentRow = { ...row }
      if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
        currentRow.billing_ym = ''
      }
      this.currentRow = currentRow
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/fees-for-stop', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    },
    deletable (row, index) {
      // 削除可能条件
      return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()) || row.regist_type === '1')
    },
    formatter (row, column) {
      // 20220509髙森修正
      // if (row.stop_fee_with_tax !== null) {
      if (row.stop_fee_without_tax !== null) {
        // 20220509髙森修正
        // return String(row.stop_fee_with_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        return String(row.stop_fee_without_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
